import React from 'react'
import { Cube } from '../../geometries/Cube'
import { RightPart } from './DoorParts/RightPart'
import { degreesToRadians } from '../../helpers'

export const DoorRight = ({ position = [0, 0, 0], rotation, scale = 1, color, height }) => {
	return (
		<group position={position} scale={[scale, scale, scale]} rotation={[0, (Math.PI / -2) - degreesToRadians(rotation), 0]} castShadow receiveShadow>
			<group position={[height / (2 * scale) - 2.5, 0, 0]} castShadow receiveShadow>
				<RightPart color={color} />
				<Cube color={color} position={[0, 25, -15]} size={[5, 50, 5]} />
			</group>
		</group>
	)
}
